import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

interface Props {
  children: React.ReactNode;
}

const PartnerProtectedRoute = ({ children }: Props) => {
  const { user, userRole, isLoading, roleLoading } = useAuth();
  const navigate = useNavigate();
  const loading = isLoading || roleLoading;

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if (userRole && userRole !== "partner" && userRole !== "admin") {
      if (userRole === "supplier") navigate("/fornecedor/painel/inicio", { replace: true });
      else navigate("/", { replace: true });
    }
  }, [loading, user, userRole, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p className="text-lg">Carregando painel do parceiro...</p>
        </div>
      </div>
    );
  }

  if (!user || (userRole && userRole !== "partner" && userRole !== "admin")) return null;
  return <>{children}</>;
};

export default PartnerProtectedRoute;
